import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './index.less';

const BackLink = ({ to, children }) => <Link to={to} className="backlink">
  <i className="fas fa-chevron-left"/>
  <span>{children}</span>
</Link>;

BackLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default BackLink;
